'use client';

export * from './client-league-tables';
